import React, { Fragment } from 'react';
import { Accordion, Row, Col } from 'react-bootstrap';
import Servico from './servico'
import '../../../styles/itens.scss';


const Item = (props) => {
    return (
        <Fragment>
            <Accordion.Item eventKey="0">
                <Accordion.Header><strong>{props.secretaria}</strong></Accordion.Header>
                <Accordion.Body>
                    <Row xs={1}>
                        {props.servicos.map((item, index) =>
                            <Col>
                                <Accordion>
                                    <Servico
                                        servico={item.servico}
                                        finalidade={item.finalidade}
                                        requisitos={item.requisitos}
                                        etapas={item.etapas}
                                        tempo={item.tempo}
                                        local={item.local}
                                        key={index}
                                    />
                                </Accordion>
                            </Col>
                        )}
                    </Row>
                </Accordion.Body>
            </Accordion.Item>
            <br />
        </Fragment>
    );
}

export default Item;